<template>
    <modal v-on:closemodal="cancelEdit" @close="cancelEdit" dialog="modal-lg" class="eventEdit-modal view dark-top">
        <div slot="title" class="fs-large mt-4 mb-3 text-center">
            {{ isCreatingSingleEvent ? 'Create New Event' : getSelectedEvent.product.name }}
        </div>

        <div slot="body" class="eventEditBody d-flex">
            <div v-if="isloadingEvent" class="text-center p-5">
                <loader></loader>
            </div>

            <div v-else class="d-flex w-100">
                <div class="col-md-3 bg-lighter darker font-weight-600 px-0 flexGrow1">
                    <ul class="pt-1">
                        <template v-for="tabItem in tabItems">
                            <li :key="tabItem.area" class="py-3 pl-3 pointer" :class="{ 'bg-light': tabItem.selected }"
                                @click="selectTabItem(tabItem)" v-if="tabItem.visible == true">
                                {{ tabItem.label }}
                                <span v-if="hasTabError(tabItem)" class="tab-error-dot"></span>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="col-md-9 overflow-test">
                    <div :is="activeArea" :validations="$v" class="pb-4"></div>
                </div>
            </div>
        </div>

        <div slot="footer">
            <footerButtons v-on:cancelEdit="cancelEdit" :validations="$v"></footerButtons>
        </div>
    </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'

import Modal from './Modal'
import Loader from '@/tools/loaders/loader1'
import $ from 'jquery'

import areaDetails from './EventEdit/areaDetails'
import areaCommunication from './EventEdit/areaCommunication'
import areaCapacity from './EventEdit/areaCapacity'
import areaResources from './EventEdit/areaResources'
import areaRulesPax from './EventEdit/areaRulesPax'
import areaSalesPermissions from './EventEdit/areaSalesPermissions'
import areaBookingQuestion from './EventEdit/areaBookingQuestion'
import areaPrices from './EventEdit/areaPrices'
import areaTransports from './EventEdit/areaTransports'
import areaCutoff from './EventEdit/areaCutoff'
import areaRules from './EventEdit/areaRules'
import footerButtons from './EventEdit/footerButtons'
import { eventFormStateHelper } from '@/store/helpers/eventFormStateHelper'

export default {
    data() {
        return {
            unModifiedEvent: null,
            activeArea: 'areaDetails',
            isloadingEvent: false
        }
    },
    created() {
        if (this.isCreatingSingleEvent) {
            this.backToList();
            this.getSelectedEvent.channelCommissions = this.getSalesChannelsForNewProduct;
            this.setHasPriceErrors(true);
        } else {
            // Saves a copy of the event to apply in case of cancel edit
            this.unModifiedEvent = JSON.parse(JSON.stringify(this.getSelectedEvent));
        }

        // Set custom agents flag
        if (this.getSelectedEvent.salesPermissionsAgentsList && this.getSelectedEvent.salesPermissionsAgentsList.length > 0) {
            this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', true);
        } else {
            this.$set(this.getSelectedEvent, 'salesPermissionsAgentsCustom', false);
        }
    },
    mounted() {
        this.setActiveArea('areaDetails');
    },
    validations: {
        getSelectedEvent: {
            product: {
                isProductValid() {
                    return this.validateProduct;
                }
            },
            location: {
                required
            },
            resources: {
                hasResources() {
                    return this.validateResources;
                }
            },
            end: {
                // Validates event duration
                isValidDuration() {
                    return this.validateDuration;
                }
            },
            rulesBook: {
                // Validate min/max per book
                isValidRulesPerBook() {
                    return this.validateRulesPaxBook;
                }
            },
            rulesEvent: {
                // Validate min lotation per event
                isValidRulesPerEvent() {
                    return this.validateRulesPaxEvent;
                }
            },
            salesChannelsAgent: {
                validateAgentChannel() {
                    return this.validateSalesChannelAgents;
                }
            },
            genderPrices: {
                validateGenderPrices() {
                    return !this.validateCustomGenderPrices;
                }
            }
        }
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        }
    },
    watch: {
        // If princingType per Order set rules Pax to 0
        'getSelectedEvent.selectedPrincingType': {
            handler(newVal) {
                if (newVal.id == 1) {
                    this.getSelectedEvent.minimumPaxPerBooking = 0;
                    this.getSelectedEvent.maximumPaxPerBooking = 0;
                    this.getSelectedEvent.minimumLotation = 0;
                    this.getSelectedEvent.rejectBookingBasedOnMinMax = false;
                    this.eventActivateUpdateFlag('minMaxRules');
                }
            }
        },
        isResourcesValid: {
            immediate: true,
            handler(val) {
                    this.setHasResourceErrors(!val);
            }
        }
    },
    computed: {
        ...mapGetters([
            'account',
            'getSelectedEvent',
            'isCreatingSingleEvent',
            'getSalesChannelsForNewProduct',
            'getHasDynamicPricingRevenuePlugin'
        ]),
        ...eventFormStateHelper.mapGetters([
            'isResourcesValid',
            'hasResourceErrors',
            'hasPriceErrors',
            'hasPriceGroupErrors'
        ]),
        tabItems() {
            if (this.isCreatingSingleEvent) {
                return [
                    {
                        label: 'Details',
                        selected: true,
                        area: 'areaDetails',
                        visible: true,
                    },
                    {
                        label: 'Resources / Capacity',
                        selected: false,
                        area: 'areaResources',
                        visible: true,
                    },
                    {
                        label: 'Prices',
                        selected: false,
                        area: 'areaPrices',
                        visible: true,
                    },
                    {
                        label: 'Sales Channels',
                        selected: false,
                        area: 'areaSalesPermissions',
                        visible: true,
                    },
                    {
                        label: 'Booking Question',
                        selected: false,
                        area: 'areaBookingQuestion',
                        visible: true,
                    },
                    {
                        label: 'Cutoff',
                        selected: false,
                        area: 'areaCutoff',
                        visible: this.featureFlags.showCutoff,
                    },
                    {
                        label: 'Min/Max Settings',
                        selected: false,
                        area: 'areaRulesPax',
                        visible: true,
                    },
                    {
                        label: 'Rules',
                        selected: false,
                        area: 'areaRules',
                        visible: this.getHasDynamicPricingRevenuePlugin,
                    },
                    {
                        label: 'Communication',
                        selected: false,
                        area: 'areaCommunication',
                        visible: true,
                    }
                ]
            } else {
                return [
                    {
                        label: 'Details',
                        selected: true,
                        area: 'areaDetails',
                        visible: true,
                    },
                    {
                        label: 'Resources / Capacity',
                        selected: false,
                        area: 'areaResources',
                        visible: true,
                    },
                    {
                        label: 'Prices',
                        selected: false,
                        area: 'areaPrices',
                        visible: true,
                    },
                    {
                        label: 'Sales Channels',
                        selected: false,
                        area: 'areaSalesPermissions',
                        visible: true,
                    },
                    {
                        label: 'Booking Question',
                        selected: false,
                        area: 'areaBookingQuestion',
                        visible: true,
                    },
                    {
                        label: 'Cutoff',
                        selected: false,
                        area: 'areaCutoff',
                        visible: this.featureFlags.showCutoff,
                    },
                    {
                        label: 'Min/Max Settings',
                        selected: false,
                        area: 'areaRulesPax',
                        visible: true,
                    },
                    {
                        label: 'Rules',
                        selected: false,
                        area: 'areaRules',
                        visible: this.getHasDynamicPricingRevenuePlugin,
                    },
                    {
                        label: 'Communication',
                        selected: false,
                        area: 'areaCommunication',
                        visible: true,
                    }
                ]
            }
        },
        validateProduct() {
            if (!this.isCreatingSingleEvent || this.isCreatingSingleEvent == false) {
                return true;
            } else {
                if (!this.getSelectedEvent.helperProduct || this.getSelectedEvent.helperProduct == null) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        validateDuration() {
            let timeDiff = moment(this.getSelectedEvent.end).diff(moment(this.getSelectedEvent.start), 'minutes');
            return timeDiff > 0;
        },
        validateRulesPaxBook() {
            if (this.getSelectedEvent.minimumPaxPerBooking != 0 && this.getSelectedEvent.maximumPaxPerBooking != 0) {
                if (this.getSelectedEvent.minimumPaxPerBooking >= this.getSelectedEvent.maximumPaxPerBooking) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return true;
            }
        },
        validateRulesPaxEvent() {
            if (
                this.getSelectedEvent.minimumLotation != 0 && this.getSelectedEvent.minimumLotation <= this.getSelectedEvent.minimumPaxPerBooking && this.getSelectedEvent.minimumPaxPerBooking != 0 ||
                this.getSelectedEvent.minimumLotation != 0 && this.getSelectedEvent.minimumLotation >= this.getSelectedEvent.maximumPaxPerBooking && this.getSelectedEvent.maximumPaxPerBooking != 0
            ) {
                return false;
            } else {
                return true;
            }
        },
        validateResources() {
            // If availbility is "Limited by Resources" we need to make sure that the event has resources
            if (this.getSelectedEvent.availabilityType == 2) {
                return this.getSelectedEvent.eventResources.length > 0;
            } else {
                return true;
            }
        },
        validateSalesChannelAgents() {
            let agentsChannel = this.getSelectedEvent.channelCommissions.filter(channel => {
                return channel.channelType == 50;
            })

            if (agentsChannel.length > 0) {
                agentsChannel = agentsChannel[0];
            } else {
                return false;
            }

            if (agentsChannel.isActive && this.getSelectedEvent.salesPermissionsAgentsCustom == true && this.getSelectedEvent.salesPermissionsAgentsList.length == 0) {
                return false;
            } else {
                return true;
            }
        },
        validateCustomGenderPrices() {
            return this.getSelectedEvent.eventGenderPrices.some(gp => {
                const audienceType = Number(gp.audienceType);

                return audienceType >= 500 && !gp.audienceTypeAssossiation;
            });
        },
    },
    methods: {
        ...mapActions([
            'openModal',
            'closeModal',
            'cancelEventEdit',
            'resetBasePrices',
            'updateSelectedEvent'
        ]),
        ...eventFormStateHelper.mapActions([
            'setHasResourceErrors',
            'setHasPriceErrors',
            'setHasPriceGroupErrors'
        ]),
        backToList() {
            // Back to calendar filters list
            $('.events .list').removeClass('moved-left');
            $('.events .more').addClass('moved-right');
        },
        selectTabItem(tabItem) {
            for (let tab of this.tabItems) {
                tab.selected = false;
            }
            tabItem.selected = true;
            this.activeArea = tabItem.area;
        },
        setActiveArea(areaName) {
            for (let tab of this.tabItems) {
                if (tab.area == areaName) {
                    tab.selected = true;
                    this.activeArea = areaName;
                } else {
                    tab.selected = false;
                }
            }
        },
        hasTabError(tabItem) {
            if (!tabItem || !tabItem.area) return false;

            const checks = {
                areaDetails: () => (!this.validateProduct || !this.validateDuration || !(this.getSelectedEvent && this.getSelectedEvent.location)),
                areaResources: () => this.hasResourceErrors,
                areaPrices: () => (this.hasPriceErrors || this.hasPriceGroupErrors || this.validateCustomGenderPrices),
            };

            const checker = checks[tabItem.area];
            return checker ? checker() : false;
        },
        cancelEdit() {
            this.cancelEventEdit(this.unModifiedEvent);

            if (this.isCreatingSingleEvent) {
                this.backToList();
                this.updateSelectedEvent(null);
            }
            
            this.setHasPriceErrors(false);
            this.setHasPriceGroupErrors(false);
            this.resetBasePrices();
            this.closeModal();
        }
    },
    components: {
        Modal,
        footerButtons,
        areaDetails,
        areaCommunication,
        areaCapacity,
        areaResources,
        areaRulesPax,
        areaSalesPermissions,
        areaBookingQuestion,
        areaPrices,
        areaTransports,
        areaCutoff,
        areaRules,
        Loader
    }
}
</script>

<style lang="scss">
// Not scopped so it affects modal-body, parent eventEdit-modal used instead of scooped
.eventEdit-modal {
    .overflowAuto {
        overflow: auto;
    }
}
</style>

<style lang="scss" scoped>
.eventEditBody {
    min-height: 460px;
}

.overflow-test {
    height: 70.9vh;
    overflow: auto;
}

.tab-error-dot {
    width: 8px;
    height: 8px;
    background: #d64545;
    border-radius: 50%;
    display: inline-block;
    margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// EventEdit.vue?0f924c4d